<!-- 
    https://v.qq.com/x/page/q3207egmfz2.html
cippe精准营销推介会—连续管作业装备工具系列产品专场完整版
https://v.qq.com/x/page/n3207ro77jd.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-杰瑞专场
https://v.qq.com/x/page/d3207eht3pb.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-开场
https://v.qq.com/x/page/i3207thupj4.html
cippe精准营销推介会—连续管作业装备工具系列产品专场-结语
   -->
<template>
  <div class="activityLive">
    <vue-particles
      class="particles"
      color="#fff"
      :particleOpacity="0.7"
      :particlesNumber="120"
      shapeType="circle"
      :particleSize="4"
      linesColor="#fff"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="2"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      >
      </vue-particles>
    <div class="w">
      <h2>
        <!-- 活动直播 -->
        <div>
          <img v-lazy="hrefurl+'/public/home/title%26bg/homeLive.png'" alt=""/>
        </div>
      </h2>
      <div class="liveContent">
        <div class="liveImg">
          <div class="swiper-container" ref="liveSwiper">
            <div class="swiper-wrapper">
              <!-- 活动直播-中国石油装备跳转链接 -->
              <div class="swiper-slide" @click="()=>{this.webHerf('https://bqfvmivzb.vzan.com/live/page/1047151935?v=1742787733151')}">
              <!-- <div class="swiper-slide"> -->
                <img :src="'https://cippe.oss-cn-beijing.aliyuncs.com/public/homelive3-1.jpg'" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="swiper-slide" @click="()=>{this.webHerf('http://e.cippe.com.cn/live')}">
                <img :src="hrefurl+'/public/home/live/homelive1-1.jpg'" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="swiper-slide" @click="()=>{this.webHerf('http://e.cippe.com.cn/live/jzyx')}">
                <img :src="hrefurl+'/public/home/live/homelive2-1.jpg'" alt=""/>
                <div class="mask"></div>
                <div class="triangleContent">
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="introduce">
          <p>
            <!-- <span @click="()=>{this.webHerf('http://e.cippe.com.cn/live')}">更多</span> -->
          </p>
          <ul class="buttonGroup">
            <li :class="{active:active==0}" @mouseover="swiperPage(1)" >
              <!-- 活动直播-中国石油装备底图 -->
              <img v-lazy="'https://cippe.oss-cn-beijing.aliyuncs.com/public/livebutton3.jpg'" alt=""/>
              <!-- <p>cippe展商直播</p> -->
              <div class="buttonTitle">
                <p >
                  <img v-lazy="hrefurl+'/public/home/live/homeButtonTitle3.png'" alt=""/>
                  <ul class="ultext">
                    <li>
                      <!-- 活动直播-中国石油装备链接2 -->
                      <a class="wailian" href="https://bqfvmivzb.vzan.com/live/page/1047151935?v=1742787733151" target="_blank">点击观看</a>
                    </li>
                  </ul>
                </p>
              </div>
            </li>
            <li :class="{active:active==1}" @mouseover="swiperPage(2)">
              <img v-lazy="hrefurl+'/public/home/live/livebutton1.jpg'" alt=""/>
              <!-- <p>cippe展会现场直播</p> -->
              <div class="buttonTitle">
                <p>
                  <img v-lazy="hrefurl+'/public/home/live/homeButtonTitle1.png'" alt=""/>
                  <ul class="ultext">
                    <li>
                      <a class="wailian" href="http://e.cippe.com.cn/live" target="_blank">点击观看</a>
                    </li>
                  </ul>
                </p>
              </div>
            </li>
            <li :class="{active:active==2}" @mouseover="swiperPage(3)">
              <img v-lazy="hrefurl+'/public/home/live/livebutton2.jpg'" alt=""/>
              <!-- <p>cippe精准营销推介会</p> -->
              <div class="buttonTitle">
                <p>
                  <img v-lazy="hrefurl+'/public/home/live/homeButtonTitle2.png'" alt=""/>
                  <ul class="ultext">
                    <li>
                      <a class="wailian" href="http://e.cippe.com.cn/live/jzyx" target="_blank">点击观看</a>
                    </li>
                  </ul>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="recommended">
        <vueSeamless class="" :data="newsList" :class-option="defaultOption" >
          <ul class="liveList">
            <!-- <li class="title">精彩推荐</li> -->
            <li v-for="(item,index) in newsList" :key="index">
              <a :href="item.href" target="_blank">
                <div>
                  <img :src="item.url" alt=""/>
                </div>
                <h5>{{item.corpname_cn}}</h5>
              </a>
            </li>
          </ul>
        </vueSeamless>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import vueSeamless from "vue-seamless-scroll";
import VueParticles from "vue-particles";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueParticles);
const newsList = [
  {
    id: 0,
    url: "http://e.cippe.com.cn/public/images/livepic22.jpg",
    name: "Kalrez®密封在油气开采中的解决方案",
    corpname_cn: "杜邦中国集团有限公司上海分公司",
    corpname_en: "杜邦中国集团有限公司上海分公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20220811/dubang.mp4",
  },
  {
    id: 1,
    url: "http://e.cippe.com.cn/public/images/livepic202201.jpg",
    name: "cippe精准营销推介会——奥创传动专场",
    corpname_cn: "奥创动力传动（深圳）有限公司",
    corpname_en: "奥创动力传动（深圳）有限公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20220712/AltraMotion.mp4",
  },
  {
    id: 2,
    url: "http://e.cippe.com.cn/public/images/livepic16.jpg",
    name: "威尔若普钢丝绳系列产品专场",
    corpname_cn: "洛阳威尔若普检测技术有限公司",
    corpname_en: "洛阳威尔若普检测技术有限公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20220610/TCK.W.mp4",
  },
  {
    id: 3,
    url: "http://e.cippe.com.cn/public/images/livepic12.jpg",
    name: "中石油连续管作业装备&工具系列产品专场",
    corpname_cn: "中石油汉江机械研究所有限公司",
    corpname_en: "中石油汉江机械研究所有限公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20210409/coiled%20tubing.mp4",
  },
  {
    id: 4,
    url: "http://e.cippe.com.cn/public/images/livepic04.jpg",
    name: "cippe高压流体系列产品专场",
    corpname_cn: "烟台杰瑞石油服务集团股份有限公司",
    corpname_en: "烟台杰瑞石油服务集团股份有限公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200710/jierui.mp4",
  },
  {
    id: 5,
    url: "http://e.cippe.com.cn/public/images/livepic19.jpg",
    name: "石油化工智能化技术与应用专场",
    corpname_cn: "摩托罗拉系统（中国）有限公司 ",
    corpname_en: "摩托罗拉系统（中国）有限公司 ",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20220708/motorola.mp4",
  },
  {
    id: 6,
    url: "http://e.cippe.com.cn/public/images/livepic06.jpg",
    name: "cippe压裂设备推介专场",
    corpname_cn: "中国石化机械四机公司",
    corpname_en: "中国石化机械四机公司",
    href: "https://cippevideo-1302098519.cos.ap-beijing.myqcloud.com/%20marketing/20200515/sijichang.mp4",
  },
];
export default {
  components: {
    vueSeamless,
  },
  data() {
    return {
      play: true, //播放状态 true为播放
      active: 1,
      newsList: newsList,
    };
  },
  mounted() {
    this.mySwiper = new Swiper(this.$refs.liveSwiper, {
      autoplay: {
        deley: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "custom",
        renderCustom: (swiper, current, total) => {
          var addHtml = "";
          for (let i = 0; i < total; i++) {
            if (i == current - 1) {
              this.active = i;
              addHtml +=
                '<span class="swiper-pagination-customs swiper-pagination-customs-active list"></span>';
            } else {
              addHtml += '<span class="swiper-pagination-customs list"></span>';
            }
          }
          return addHtml;
        },
      },
      loop: true,
    });
    this.mySwiper.el.onmouseover = this.swiperStop;
    this.mySwiper.el.onmouseout = this.swiperStart;
  },
  methods: {
    swiperStop() {
      this.mySwiper.autoplay.stop();
    },
    swiperStart() {
      if (!this.play) {
        this.mySwiper.autoplay.start();
      }
    },
    swiperPage(i) {
      this.mySwiper.slideTo(i);
    },
  },
  computed: {
    defaultOption() {
      return {
        step: .5,
        direction: 2,
        limitMoveNum: 7,
        hoverStop: true,
        openWatch: true,
      };
    },
  },
};
</script>
<style scoped>
.w {
  max-width: 1200px;
  margin: 0 auto;
}
.active {
  color: sandybrown;
}
.particles {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.activityLive {
  position: relative;
  background: #1158a3
    url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/title&bg/homeLiveBg.jpg")
    no-repeat top center;
  background-size: 100% 100%;
  padding-bottom: 30px;
  /* height: 100%;
    max-height: 875px; */
}
.activityLive .w {
  position: relative;
  z-index: 99;
}
.activityLive h2 {
  font-size: 40px;
  text-align: center;
  padding: 70px 0 50px;
  color: #008baf;
  font-weight: 600;
}
.activityLive h2 > div {
  width: 300px;
  height: 80px;
  overflow: hidden;
  margin: 0 auto;
}
.liveContent {
  height: 500px;
  padding: 30px 20px 20px;
  background-color: rgba(0, 0, 0, 0.4);
}
.liveImg {
  width: 70%;
  height: 450px;
  margin-right: 30px;
  display: inline-block;
  overflow: hidden;
}
.liveImg >>> .swiper-container {
  height: 100%;
}
.liveImg >>> .swiper-slide {
  cursor: pointer;
}
.triangleContent {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  padding: 15px;
  padding-left: 23px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
}
.triangle {
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 32px solid #008baf;
}
.mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}
.liveImg >>> .list {
  color: royalblue;
}
.chainContent {
  width: 100%;
  height: 500px;
  margin: auto;
}
.chian {
  width: 100%;
  height: 100%;
}
.introduce {
  width: calc(30% - 30px);
  display: inline-block;
  color: white;
  vertical-align: top;
  height: 100%;
  position: relative;
}
h3 {
  font-size: 22px;
  margin-bottom: 30px;
  line-height: 40px;
}
h6 {
  font-size: 16px;
  font-weight: 600;
}
.introduce > p {
  position: absolute;
  display: inline-block;
  line-height: 1;
  vertical-align: top;
  width: 100%;
  text-align: end;
  right: 0;
  top: -30px;
  font-size: 16px;
}
.introduce > p span {
  cursor: pointer;
  padding-bottom: 2px;
}
.introduce > p span:hover {
  border-bottom: 1px solid white;
}
.introduce .buttonGroup {
  height: 100%;
  text-align: center;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.introduce .buttonGroup li {
  position: relative;
  color: white;
  overflow: hidden;
}
.introduce .buttonGroup li img {
  object-fit: cover;
}
.introduce .buttonGroup li .buttonTitle {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
  cursor: pointer;
  background-color: rgba(0, 139, 175, 0.3);
}
.introduce .buttonGroup li .buttonTitle:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
.buttonTitle p {
  transition: margin 0.5s;
  width: 100%;
}
.buttonTitle:hover p {
  margin-top: -20px;
}
.ultext {
  margin-top: -40px;
  opacity: 0;
  transition: opacity 0.5s;
  font-size: 12px;
}
.buttonTitle:hover .ultext {
  opacity: 1;
}
.wailian {
  color: white;
  font-size: 16px;
  font-weight: 600;
}
.wailian:hover {
  color: #f08300;
}
/* 推荐列表 */
.recommended {
  max-height: 278px;
  width: 100%;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.8);
}
.recommended > div {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
.liveList {
  display: inline-block;
}
.liveList li {
  display: inline-block;
  text-align: center;
  padding-left: 20px;
  width: 270px;
  box-sizing: border-box;
}
h5 {
  color: white;
  font-weight: 600;
  font-size: 14px;
}
</style>
